/**
 * @Date:   2021-01-22 06:13:27
 * @Filename: computed.js
 * @Last modified time: 2021-01-22 06:14:12
 */

export default {};